import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94c270ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["viewBox"]
const _hoisted_2 = {
  key: 1,
  class: "ProgressBar"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ProgressBar__Tracker" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollProgressLine = _resolveComponent("ScrollProgressLine")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.chapter.slides.length <= 30)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: "Progress",
          viewBox: _ctx.Viewport.isMobile ? `0 0 335 4` : `0 0 4 ${14 * (_ctx.chapter.slides.length + 1) + 37}`,
          preserveAspectRatio: "xMidYMid meet"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapter.slides.length + 2, (index) => {
            return (_openBlock(), _createBlock(_component_ScrollProgressLine, {
              key: `dots-${index}`,
              start: _ctx.getStart(index - 1),
              end: _ctx.getEnd(index - 1),
              max: 14 * (_ctx.chapter.slides.length + 1) + 37,
              class: _normalizeClass({ 'viewed' : index <= _ctx.maxIndex }),
              "data-index": index
            }, null, 8, ["start", "end", "max", "class", "data-index"]))
          }), 128))
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ]))
}